import LandingPage from "@modules/homepage/LandingPage"

import CommonRepo from "@api/server-side/common.repo"

export async function getServerSideProps() {
  const common = new CommonRepo()

  try {
    const res2 = common.getBannerInfo()

    let banner = null

    const [bnr] = await Promise.allSettled([res2])

    if (bnr.status === "fulfilled" && bnr.value) {
      banner = JSON.parse(bnr.value.body).result
    }

    return {
      props: {
        infoAlumni: banner,
      },
    }
  } catch (e) {
    console.log(e)

    return {
      props: {
        youtubeVideo: [],
        infoAlumni: null,
      },
    }
  }
}

export default LandingPage
